<template>
  <v-menu
    ref="optionsMenu"
    v-model="showOptions"
    data-id-e2e="product-attribute-options"
    :close-on-content-click="false"
    width="400"
  >
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        :disabled="disabled"
        class="mr-2 outlined-btn reset-kpi-button"
        variant="flat"
        secondary
      >
        {{ $t('general.options') }}
      </v-btn>
    </template>
    <TransferPriceSettings
      v-if="hasTransferPriceEnabled"
      @sync-financials="emitSyncFinancials"
      @update-maintain="emitBulkUpdateMaintain"
    />
  </v-menu>
</template>

<script>
import { useContextStore } from '@/stores/context';
import { get } from 'lodash';
import { mapState } from 'pinia';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({ showOptions: false }),

  computed: {
    ...mapState(useContextStore, ['getClientConfig']),
    hasTransferPriceEnabled() {
      return get(this.getClientConfig, 'features.productsInResetEnabled', false);
    },
  },

  methods: {
    emitSyncFinancials(transferPriceRange) {
      this.$emit('sync-financials', transferPriceRange);
    },

    emitBulkUpdateMaintain(newMaintainValue) {
      this.$emit('update-maintain', newMaintainValue);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';
.v-menu__content {
  padding: 2.5rem 1.5rem;
  background-color: $assortment-background;
}
</style>
